import { render, staticRenderFns } from "./VehicleSearch.vue?vue&type=template&id=fb46df86&scoped=true&"
import script from "./VehicleSearch.vue?vue&type=script&lang=ts&"
export * from "./VehicleSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb46df86",
  null
  
)

export default component.exports